// auth.service.ts
import { Injectable } from '@angular/core'
import { getAuth, signInWithPopup, GoogleAuthProvider, Auth } from '@angular/fire/auth'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private validDomains = ['cellpodium.com', 's5-tech.com']

  constructor() {}

  async signInWithGoogle(): Promise<boolean> {
    const auth: Auth = getAuth()
    const googleAuthProvider = new GoogleAuthProvider()

    try {
      const credential = await signInWithPopup(auth, googleAuthProvider)

      if (!credential.user?.email) {
        await auth.signOut()
        console.log('Authentication failed: User email is missing')
        return false
      }

      const domain = credential.user.email.split('@')[1].toLowerCase()
      if (!this.validDomains.includes(domain)) {
        await auth.signOut()
        console.log(`Authentication failed: User email domain '${domain}' is not valid`)
        return false
      }

      console.log('User authenticated successfully')
      return true
    } catch (error: any) {
      console.log(`Authentication error: ${(error as Error).message}`)
      alert((error as Error).message)
      return false
    }
  }

  isAuthenticated(): boolean {
    return getAuth().currentUser != null
  }

  async initializeAuth(onAuthenticated: () => Promise<void>): Promise<boolean> {
    if (this.isAuthenticated()) {
      await onAuthenticated()
      return true
    }
    return false
  }
}
